import GET_USER_BY_CPF from './getUserByCpf.gql';

export default GET_USER_BY_CPF;
export {
  GET_USER_BY_CPF,
};
